var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary-100 h-full font-inter",attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath.split('#')[0]}),_c('portal-target',{attrs:{"name":"destination","multiple":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }